<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M55.406 128.228c1.947,-22.947 -2.564,-46.947 -13.533,-71.999 18.666,32.318 24.787,56.393 18.363,72.226 -1.241,-0.127 -2.56,-0.084 -4.83,-0.227z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M36.637 124.79c1.947,-22.947 -2.564,-46.947 -13.533,-71.999 18.666,32.318 24.787,56.393 18.363,72.226 -1.242,-0.127 -2.56,-0.084 -4.83,-0.227z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M25.116 184.963c5.314,-8.214 12.02,-13.059 18.903,-15.168 9.564,-2.931 19.467,-0.579 26.442,5.354 2.239,1.905 4.177,4.179 5.705,6.767 -4.714,5.797 -11.42,8.462 -18.019,6.268 -1.032,-0.342 -1.999,-0.714 -2.912,-1.097 -4.851,-2.036 -8.172,-4.408 -11.646,-4.687 -2.213,-0.177 -4.195,0.215 -6.167,0.763 -2.362,0.658 -4.71,1.539 -7.427,1.936 -1.788,0.261 -3.416,0.194 -4.879,-0.136z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M70.461 175.149c-2.727,-7.616 -3.638,-14.575 -2.733,-20.876 6.657,-0.429 13.066,-2.11 14.455,-6.805 1.409,9.705 1.388,18.906 -1.865,27.22 -1.075,2.748 -2.49,5.182 -4.152,7.228 -1.528,-2.588 -3.466,-4.862 -5.705,-6.767z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M67.728 154.273c-3.718,0.24 -7.513,0.09 -10.554,-0.143 -16.759,-1.285 -27.437,-3.628 -37.753,-6.309 0.134,-0.71 0.24,-1.368 0.318,-1.973 4.733,-3.218 11.512,-3.921 20.335,-2.109 4.819,3.301 12.242,3.301 22.269,0 5.296,-2.208 11.575,-2.923 18.838,-2.147 0.381,1.976 0.72,3.936 1.002,5.876 -1.389,4.695 -7.798,6.376 -14.455,6.805z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M44.025 169.793c-1.515,-7.405 -2.229,-11.431 -3.187,-17.479 4.81,0.725 10.16,1.342 16.336,1.816 3.041,0.233 6.836,0.383 10.554,0.143 -0.905,6.301 0.006,13.26 2.733,20.876 -6.974,-5.932 -16.874,-8.284 -26.436,-5.356z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M40.838 152.314c0.958,6.048 1.672,10.074 3.181,17.481 -5.474,1.678 -10.837,5.085 -15.476,10.543 -1.21,1.4 -2.371,2.937 -3.472,4.615 -5.048,-1.156 -8.121,-5.427 -9.054,-9.977 -1.32,-6.428 -1.417,-11.68 0.001,-15.521 1.743,-4.719 2.834,-8.637 3.403,-11.634 6.515,1.693 13.173,3.251 21.417,4.493z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M37.422 183.163c3.8,6.147 9.738,7.455 17.813,3.924m-35.496 -41.239c4.733,-3.218 11.512,-3.921 20.335,-2.109 4.819,3.301 12.242,3.301 22.269,0 5.296,-2.208 11.575,-2.923 18.838,-2.147m-65.164 33.384c-1.32,-6.428 -1.417,-11.68 0.001,-15.521 2.793,-7.564 3.911,-13.068 3.892,-16.023 -0.093,-14.705 1.774,-22.663 2.411,-30.336 0.676,-8.14 0.064,-20.244 -0.193,-28.985 -0.204,-6.934 -6.525,-44.488 0.851,-45.521 3.254,-0.456 6.155,5.429 7.4,7.76 1.534,2.876 3.077,6.282 4.073,8.596 0.996,2.314 2.874,6.275 2.135,4.09 -0.738,-2.185 -4.096,-10.518 -5.091,-14.116 -3.49,-12.609 3.065,-11.757 10.765,-3.76 2.506,2.603 5.334,5.946 8.483,10.701 3.149,4.756 6.62,10.927 10.38,18.928 3.76,8.002 7.81,17.835 10.669,26.351 2.86,8.515 4.532,15.714 5.753,22.045 1.22,6.331 1.21,11.304 2.265,15.938 3.24,14.241 5.113,27.793 0.507,39.565 -4.123,10.541 -13.245,16.464 -22.171,13.496 -6.519,-2.167 -10.43,-5.453 -14.558,-5.784 -4.864,-0.39 -8.61,1.971 -13.594,2.699 -7.995,1.169 -12.772,-4.245 -13.978,-10.123z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>

